import AxiosMember from './axios_member'

const ModuleMember = {
  state: {
    stateListMemberLevelRank: [],
    stateListMemberRanked: [],
    stateCreateMember: [],
    stateDropdownPrivilege: [],
    stateListMemberDetail: [],
    stateUpdateMember: [],
    stategetListUserPointBySellerShopID: [],
    stategetUserMemberCrm: [],
    stategetDetailMemberCrm: [],
    stateGrantCoupon: [],
    stateGrantPoint: [],
    stateDeductPoint: [],
    stateRegisterShopMember: [],
    stateGetCuscodeDetail: [],
    stateGetListOrderMember: [],
    stateUpdateCustomDiscount: [],
    stateExportMembers: [],
    stateCreateCouponCrm: [],
    stateCreateMemberLevel: [],
    stateEditMemberLevel: [],
    stateGetMemberLevelDetaill: [],
    stateDeleteMemberLevel: [],
    stateGetMemberLavelProgress: [],
    stateGetMemberPointTransactions: [],
    stateCheckLevelPopup: [],
    stateUpdateLevelPopup: [],
    stateFollowShop: [],
    stateListMemberLevel: [],
    stateGetMemberCoupon: [],
    stateDashboardMember: [],
    stateGetMemberShopMine: [],
    stateGetMemberBenefit: [],
    stateGetMemberProduct: [],
    stateGetMemberActivities: [],
    stateGetMemberShopOpen: [],
    stateGetLevelBenefit: [],
    stateCreateAnnouncement: [],
    stateDetailAnnouncement: [],
    stateUpdateAnnouncement: [],
    stateListAnnouncement: [],
    stateDeleteAnnouncement: [],
    stateLevelCouponCreate: [],
    stateDetailCouponLevel: [],
    stateUpdateLevelCoupon: [],
    stateListLevelCoupon: [],
    stateStatusLevelCoupon: [],
    stateDeleteLevelCoupon: [],
    stateExportMember: [],
    stateTemplateLevelCoupon: [],
    stateImportLevelCoupon: [],
    stateMonitorShopOpened: [],
    stateMembershipTotal: [],
    stateMembershipUnique: [],
    stateOrdersByMember: [],
    stateOrdersByShop: [],
    stateGetMembersDashboard: [],
    stateUpdateBirthdatePopup: [],
    stateCheckTypeSpecialDeal: [],
    stateMemberSpecialDeals: [],
    stateSpecialDealsMode: [],
    stateSpecialDealsSetting: [],
    stateSpecialDealsList: [],
    stateSpecialDealsDetail: [],
    stateSpecialDealsCreate: [],
    stateSpecialDealsUpdate: [],
    stateSpecialDealsStatus: [],
    stateSpecialDealsDelete: [],
    stateSpecialDealsProductList: [],
    stateSpecialDealsBuyerList: [],
    stateSpecialDealsLevelList: [],
    stateSpecialDealsCheckTypeOptions: [],
    stateShopAdsDetail: [],
    stateShopAdsUpdate: [],
    stateShopAdsDelete: [],
    stateGetShopADS: [],
    stateMemberShopSearch: [],
    stateMemberPointRedeemProducts: [],
    stateCreateOrderPointRedeem: [],
    stateMemberCustomCouponDetail: [],
    stateMemberCustomCouponSave: [],
    stateManageStatusMember: [],
    stateUpdateStatusMember: []
  },
  mutations: {
    mutationsListMemberLevelRank (state, data) {
      state.stateListMemberLevelRank = data
    },
    mutationsListMemberRanked (state, data) {
      state.stateListMemberRanked = data
    },
    mutationsCreateMember (state, data) {
      state.stateCreateMember = data
    },
    mutationsDropdownPrivilege (state, data) {
      state.stateDropdownPrivilege = data
    },
    mutationsListMemberDetail (state, data) {
      state.stateListMemberDetail = data
    },
    mutationsUpdateMember (state, data) {
      state.stateUpdateMember = data
    },
    mutationsgetListUserPointBySellerShopID (state, data) {
      state.stategetListUserPointBySellerShopID = data
    },
    mutationsgetUserMemberCrm (state, data) {
      state.stategetUserMemberCrm = data
    },
    mutationsgetDetailMemberCrm (state, data) {
      state.stategetDetailMemberCrm = data
    },
    mutationsGrantCoupon (state, data) {
      state.stateGrantCoupon = data
    },
    mutationsGrantPoint (state, data) {
      state.stateGrantPoint = data
    },
    mutationsDeductPoint (state, data) {
      state.stateDeductPoint = data
    },
    mutationRegisterShopMember (state, data) {
      state.stateRegisterShopMember = data
    },
    mutationGetCuscodeDetail (state, data) {
      state.stateGetCuscodeDetail = data
    },
    mutationGetListOrderMember (state, data) {
      state.stateGetListOrderMember = data
    },
    mutationUpdateCustomDiscount (state, data) {
      state.stateUpdateCustomDiscount = data
    },
    mutationExportMembers (state, data) {
      state.stateExportMembers = data
    },
    mutationsCreateCouponCrm (state, data) {
      state.stateCreateCouponCrm = data
    },
    mutationsCreateMemberLevel (state, data) {
      state.stateCreateMemberLevel = data
    },
    mutationsEditMemberLevel (state, data) {
      state.stateEditMemberLevel = data
    },
    mutationsGetMemberLevelDetail (state, data) {
      state.stateGetMemberLevelDetaill = data
    },
    mutationsDeleteMemberLevel (state, data) {
      state.stateDeleteMemberLevel = data
    },
    mutationsListCouponMember (state, data) {
      state.stateListCouponMember = data
    },
    mutationsGetMemberLavelProgress (state, data) {
      state.stateGetMemberLavelProgress = data
    },
    mutationsGetMemberPointTransactions (state, data) {
      state.stateGetMemberPointTransactions = data
    },
    mutationsCheckLevelPopup (state, data) {
      state.stateCheckLevelPopup = data
    },
    mutationsUpdateLevelPopup (state, data) {
      state.stateUpdateLevelPopup = data
    },
    mutationsFollowShop (state, data) {
      state.stateFollowShop = data
    },
    mutationsListMemberLevel (state, data) {
      state.stateListMemberLevel = data
    },
    mutationsGetMemberCoupon (state, data) {
      state.stateGetMemberCoupon = data
    },
    mutationsDashboardMember (state, data) {
      state.stateDashboardMember = data
    },
    mutationsGetMemberShopMine (state, data) {
      state.stateGetMemberShopMine = data
    },
    mutationsGetMemberBenefit (state, data) {
      state.stateGetMemberBenefit = data
    },
    mutationsGetMemberProduct (state, data) {
      state.stateGetMemberProduct = data
    },
    mutationsGetMemberActivities (state, data) {
      state.stateGetMemberActivities = data
    },
    mutationsGetMemberShopOpen (state, data) {
      state.stateGetMemberShopOpen = data
    },
    mutationsGetLevelBenefit (state, data) {
      state.stateGetLevelBenefit = data
    },
    mutationsCreateAnnouncement (state, data) {
      state.stateCreateAnnouncement = data
    },
    mutationsDetailAnnouncement (state, data) {
      state.stateDetailAnnouncement = data
    },
    mutationsUpdateAnnouncement (state, data) {
      state.stateUpdateAnnouncement = data
    },
    mutationsListAnnouncement (state, data) {
      state.stateListAnnouncement = data
    },
    mutationsDeleteAnnouncement (state, data) {
      state.stateDeleteAnnouncement = data
    },
    mutationsLevelCouponCreate (state, data) {
      state.stateLevelCouponCreate = data
    },
    mutationsDetailCouponLevel (state, data) {
      state.stateDetailCouponLevel = data
    },
    mutationsUpdateLevelCoupon (state, data) {
      state.stateUpdateLevelCoupon = data
    },
    mutationsListLevelCoupon (state, data) {
      state.stateListLevelCoupon = data
    },
    mutationsStatusLevelCoupon (state, data) {
      state.stateStatusLevelCoupon = data
    },
    mutationsDeleteLevelCoupon (state, data) {
      state.stateDeleteLevelCoupon = data
    },
    mutationsExportMember (state, data) {
      state.stateExportMember = data
    },
    mutationsTemplateLevelCoupon (state, data) {
      state.stateTemplateLevelCoupon = data
    },
    mutationsImportLevelCoupon (state, data) {
      state.stateImportLevelCoupon = data
    },
    mutationsMonitorShopOpened (state, data) {
      state.stateMonitorShopOpened = data
    },
    mutationsMembershipTotal (state, data) {
      state.stateMembershipTotal = data
    },
    mutationsMembershipUnique (state, data) {
      state.stateMembershipUnique = data
    },
    mutationsOrdersByMember (state, data) {
      state.stateOrdersByMember = data
    },
    mutationsOrdersByShop (state, data) {
      state.stateOrdersByShop = data
    },
    mutationsGetMembersDashboard (state, data) {
      state.stateGetMembersDashboard = data
    },
    mutationsUpdateBirthdatePopup (state, data) {
      state.stateUpdateBirthdatePopup = data
    },
    mutationsCheckTypeSpecialDeal (state, data) {
      state.stateCheckTypeSpecialDeal = data
    },
    mutationsMemberSpecialDeals (state, data) {
      state.stateMemberSpecialDeals = data
    },
    mutationsSpecialDealsMode (state, data) {
      state.stateSpecialDealsMode = data
    },
    mutationsSpecialDealsSetting (state, data) {
      state.stateSpecialDealsSetting = data
    },
    mutationsSpecialDealsList (state, data) {
      state.stateSpecialDealsList = data
    },
    mutationsSpecialDealsDetail (state, data) {
      state.stateSpecialDealsDetail = data
    },
    mutationsSpecialDealsCreate (state, data) {
      state.stateSpecialDealsCreate = data
    },
    mutationsSpecialDealsUpdate (state, data) {
      state.stateSpecialDealsUpdate = data
    },
    mutationsSpecialDealsStatus (state, data) {
      state.stateSpecialDealsStatus = data
    },
    mutationsSpecialDealsDelete (state, data) {
      state.stateSpecialDealsDelete = data
    },
    mutationsSpecialDealsProductList (state, data) {
      state.stateSpecialDealsProductList = data
    },
    mutationsSpecialDealsBuyerList (state, data) {
      state.stateSpecialDealsBuyerList = data
    },
    mutationsSpecialDealsLevelList (state, data) {
      state.stateSpecialDealsLevelList = data
    },
    mutationsSpecialDealsCheckTypeOptions (state, data) {
      state.stateSpecialDealsCheckTypeOptions = data
    },
    mutationsShopAdsDetail (state, data) {
      state.stateShopAdsDetail = data
    },
    mutationsShopAdsUpdate (state, data) {
      state.stateShopAdsUpdate = data
    },
    mutationsShopAdsDelete (state, data) {
      state.stateShopAdsDelete = data
    },
    mutationsGetShopADS (state, data) {
      state.stateGetShopADS = data
    },
    mutationsMemberShopSearch (state, data) {
      state.stateMemberShopSearch = data
    },
    mutationsMemberPointRedeemProducts (state, data) {
      state.stateMemberPointRedeemProducts = data
    },
    mutationsCreateOrderPointRedeem (state, data) {
      state.stateCreateOrderPointRedeem = data
    },
    mutationsMemberCustomCouponDetail (state, data) {
      state.stateMemberCustomCouponDetail = data
    },
    mutationsMemberCustomCouponSave (state, data) {
      state.stateMemberCustomCouponSave = data
    },
    mutationsManageStatusMember (state, data) {
      state.stateManageStatusMember = data
    },
    mutationsUpdateStatusMember (state, data) {
      state.stateUpdateStatusMember = data
    }
  },
  actions: {
    async actionsListMemberLevelRank (context, access) {
      var response = await AxiosMember.ListMemberLevelRank(access)
      await context.commit('mutationsListMemberLevelRank', response)
    },
    async actionsListMemberRanked (context, access) {
      var response = await AxiosMember.ListMemberRanked(access)
      await context.commit('mutationsListMemberRanked', response)
    },
    async actionsCreateMember (context, access) {
      var response = await AxiosMember.CreateMember(access)
      await context.commit('mutationsCreateMember', response)
    },
    async actionsDropdownPrivilege (context, access) {
      var response = await AxiosMember.DropdownPrivilege(access)
      await context.commit('mutationsDropdownPrivilege', response)
    },
    async actionsListMemberDetail (context, access) {
      var response = await AxiosMember.ListMemberDetail(access)
      await context.commit('mutationsListMemberDetail', response)
    },
    async actionsUpdateMember (context, access) {
      var response = await AxiosMember.UpdateMember(access)
      await context.commit('mutationsUpdateMember', response)
    },
    async actionsgetListUserPointBySellerShopID (context, access) {
      const responseData = await AxiosMember.getListUserPointBySellerShopID(access)
      // console.log('response', responseData)
      await context.commit('mutationsgetListUserPointBySellerShopID', responseData)
    },
    async actionsgetUserMemberCrm (context, access) {
      const responseData = await AxiosMember.getUserMemberCrm(access)
      // console.log('response', responseData)
      await context.commit('mutationsgetUserMemberCrm', responseData)
    },
    async actionsgetDetailMemberCrm (context, access) {
      const responseData = await AxiosMember.getDetailMemberCrm(access)
      // console.log('response', responseData)
      await context.commit('mutationsgetDetailMemberCrm', responseData)
    },
    async actionGrantCoupon (context, access) {
      var responseData = await AxiosMember.GrantCoupon(access)
      await context.commit('mutationsGrantCoupon', responseData)
    },
    async actionGrantPoint (context, access) {
      var responseData = await AxiosMember.GrantPoint(access)
      await context.commit('mutationsGrantPoint', responseData)
    },
    async actionDeductPoint (context, access) {
      var responseData = await AxiosMember.DeductPoint(access)
      await context.commit('mutationsDeductPoint', responseData)
    },
    async actionRegisterShopMember (context, access) {
      var responseData = await AxiosMember.RegisterShopMember(access)
      await context.commit('mutationRegisterShopMember', responseData)
    },
    async actionGetCuscodeDetail (context, access) {
      var responseData = await AxiosMember.GetCuscodeDetail(access)
      await context.commit('mutationGetCuscodeDetail', responseData)
    },
    async actionGetListOrderMember (context, access) {
      var responseData = await AxiosMember.GetListOrderMember(access)
      await context.commit('mutationGetListOrderMember', responseData)
    },
    async actionUpdateCustomDiscount (context, access) {
      var responseData = await AxiosMember.UpdateCustomDiscount(access)
      await context.commit('mutationUpdateCustomDiscount', responseData)
    },
    async actionExportMembers (context, access) {
      var responseData = await AxiosMember.ExportMembers(access)
      await context.commit('mutationExportMembers', responseData)
    },
    async actionCreateCouponCrm (context, access) {
      var responseData = await AxiosMember.CreateCouponCrm(access)
      await context.commit('mutationsCreateCouponCrm', responseData)
    },
    async actionCreateMemberLevel (context, access) {
      var responseData = await AxiosMember.CreateMemberLevel(access)
      await context.commit('mutationsCreateMemberLevel', responseData)
    },
    async actionEditMemberLevel (context, access) {
      var responseData = await AxiosMember.EditMemberLevel(access)
      await context.commit('mutationsEditMemberLevel', responseData)
    },
    async actionGetMemberLevelDetail (context, access) {
      var responseData = await AxiosMember.GetMemberLevelDetail(access)
      await context.commit('mutationsGetMemberLevelDetail', responseData)
    },
    async actionDeleteMemberLevel (context, access) {
      var responseData = await AxiosMember.DeleteMemberLevel(access)
      await context.commit('mutationsDeleteMemberLevel', responseData)
    },
    async actionListCouponMember (context, access) {
      var responseData = await AxiosMember.ListCouponMember(access)
      await context.commit('mutationsListCouponMember', responseData)
    },
    async actionGetMemberLavelProgress (context, access) {
      var responseData = await AxiosMember.GetMemberLavelProgress(access)
      await context.commit('mutationsGetMemberLavelProgress', responseData)
    },
    async actionGetMemberPointTransactions (context, access) {
      var responseData = await AxiosMember.GetMemberPointTransactions(access)
      await context.commit('mutationsGetMemberPointTransactions', responseData)
    },
    async actionCheckLevelPopup (context, access) {
      var responseData = await AxiosMember.CheckLevelPopup(access)
      await context.commit('mutationsCheckLevelPopup', responseData)
    },
    async actionUpdateLevelPopup (context, access) {
      var responseData = await AxiosMember.UpdateLevelPopup(access)
      await context.commit('mutationsUpdateLevelPopup', responseData)
    },
    async actionFollowShop (context, access) {
      var responseData = await AxiosMember.FollowShop(access)
      await context.commit('mutationsFollowShop', responseData)
    },
    async actionsListMemberLevel (context, access) {
      var responseData = await AxiosMember.ListMemberLevel(access)
      await context.commit('mutationsListMemberLevel', responseData)
    },
    async actionsGetMemberCoupon (context, access) {
      var responseData = await AxiosMember.GetMemberCoupon(access)
      await context.commit('mutationsGetMemberCoupon', responseData)
    },
    async actionsDashboardMember (context, access) {
      var response = await AxiosMember.DashboardMember(access)
      await context.commit('mutationsDashboardMember', response)
    },
    async actionsGetMemberShopMine (context, access) {
      var response = await AxiosMember.GetMemberShopMine(access)
      await context.commit('mutationsGetMemberShopMine', response)
    },
    async actionsGetMemberBenefit (context, access) {
      var response = await AxiosMember.GetMemberBenefit(access)
      await context.commit('mutationsGetMemberBenefit', response)
    },
    async actionsGetMemberProduct (context, access) {
      var response = await AxiosMember.GetMemberProduct(access)
      await context.commit('mutationsGetMemberProduct', response)
    },
    async actionsGetMemberActivities (context, access) {
      var response = await AxiosMember.GetMemberActivities(access)
      await context.commit('mutationsGetMemberActivities', response)
    },
    async actionsGetMemberShopOpen (context, access) {
      var response = await AxiosMember.GetMemberShopOpen(access)
      await context.commit('mutationsGetMemberShopOpen', response)
    },
    async actionsGetLevelBenefit (context, access) {
      var response = await AxiosMember.GetLevelBenefit(access)
      await context.commit('mutationsGetLevelBenefit', response)
    },
    async actionsCreateAnnouncement (context, access) {
      var response = await AxiosMember.CreateAnnouncement(access)
      await context.commit('mutationsCreateAnnouncement', response)
    },
    async actionsDetailAnnouncement (context, access) {
      var response = await AxiosMember.DetailAnnouncement(access)
      await context.commit('mutationsDetailAnnouncement', response)
    },
    async actionsUpdateAnnouncement (context, access) {
      var response = await AxiosMember.UpdateAnnouncement(access)
      await context.commit('mutationsUpdateAnnouncement', response)
    },
    async actionsListAnnouncement (context, access) {
      var response = await AxiosMember.ListAnnouncement(access)
      await context.commit('mutationsListAnnouncement', response)
    },
    async actionsDeleteAnnouncement (context, access) {
      var response = await AxiosMember.DeleteAnnouncement(access)
      await context.commit('mutationsDeleteAnnouncement', response)
    },
    async actionsLevelCouponCreate (context, access) {
      var response = await AxiosMember.CreateLevelCoupon(access)
      await context.commit('mutationsLevelCouponCreate', response)
    },
    async actionsDetailCouponLevel (context, access) {
      var response = await AxiosMember.DetailCouponLevel(access)
      await context.commit('mutationsDetailCouponLevel', response)
    },
    async actionsUpdateLevelCoupon (context, access) {
      var response = await AxiosMember.UpdateLevelCoupon(access)
      await context.commit('mutationsUpdateLevelCoupon', response)
    },
    async actionsListLevelCoupon (context, access) {
      var response = await AxiosMember.ListLevelCoupon(access)
      await context.commit('mutationsListLevelCoupon', response)
    },
    async actionsStatusLevelCoupon (context, access) {
      var response = await AxiosMember.StatusLevelCoupon(access)
      await context.commit('mutationsStatusLevelCoupon', response)
    },
    async actionsDeleteLevelCoupon (context, access) {
      var response = await AxiosMember.DeleteLevelCoupon(access)
      await context.commit('mutationsDeleteLevelCoupon', response)
    },
    async actionsExportMember (context, access) {
      var response = await AxiosMember.ExportMember(access)
      await context.commit('mutationsExportMember', response)
    },
    async actionsTemplateLevelCoupon (context, access) {
      var response = await AxiosMember.TemplateLevelCoupon(access)
      await context.commit('mutationsTemplateLevelCoupon', response)
      return response
    },
    async actionsImportLevelCoupon (context, access) {
      var response = await AxiosMember.ImportLevelCoupon(access)
      await context.commit('mutationsImportLevelCoupon', response)
      return response
    },
    async actionsMonitorShopOpened (context, access) {
      var response = await AxiosMember.MonitorShopOpened(access)
      await context.commit('mutationsMonitorShopOpened', response)
      return response
    },
    async actionsMembershipTotal (context, access) {
      var response = await AxiosMember.MembershipTotal(access)
      await context.commit('mutationsMembershipTotal', response)
      return response
    },
    async actionsMembershipUniquel (context, access) {
      var response = await AxiosMember.MembershipUnique(access)
      await context.commit('mutationsMembershipUnique', response)
      return response
    },
    async actionsOrdersByMember (context, access) {
      var response = await AxiosMember.OrdersByMember(access)
      await context.commit('mutationsOrdersByMember', response)
      return response
    },
    async actionsOrdersByShop (context, access) {
      var response = await AxiosMember.OrdersByShop(access)
      await context.commit('mutationsOrdersByShop', response)
      return response
    },
    async actionsGetMembersDashboard (context, access) {
      var response = await AxiosMember.GetMembersDashboard(access)
      await context.commit('mutationsGetMembersDashboard', response)
      return response
    },
    async actionsUpdateBirthdatePopup (context, access) {
      var response = await AxiosMember.UpdateBirthdatePopup(access)
      await context.commit('mutationsUpdateBirthdatePopup', response)
      return response
    },
    async actionsCheckTypeSpecialDeal (context, access) {
      var response = await AxiosMember.checkTypeSpecialDeal(access)
      await context.commit('mutationsCheckTypeSpecialDeal', response)
      return response
    },
    async actionsMemberSpecialDeals (context, access) {
      var response = await AxiosMember.MemberSpecialDeals(access)
      await context.commit('mutationsMemberSpecialDeals', response)
      return response
    },
    async actionsSpecialDealsMode (context, access) {
      var response = await AxiosMember.SpecialDealsMode(access)
      await context.commit('mutationsSpecialDealsMode', response)
      return response
    },
    async actionsSpecialDealsSetting (context, access) {
      var response = await AxiosMember.SpecialDealsSetting(access)
      await context.commit('mutationsSpecialDealsSetting', response)
      return response
    },
    async actionsSpecialDealsList (context, access) {
      var response = await AxiosMember.SpecialDealsList(access)
      await context.commit('mutationsSpecialDealsList', response)
      return response
    },
    async actionsSpecialDealsDetail (context, access) {
      var response = await AxiosMember.SpecialDealsDetail(access)
      await context.commit('mutationsSpecialDealsDetail', response)
      return response
    },
    async actionsSpecialDealsCreate (context, access) {
      var response = await AxiosMember.SpecialDealsCreate(access)
      await context.commit('mutationsSpecialDealsCreate', response)
      return response
    },
    async actionsSpecialDealsUpdate (context, access) {
      var response = await AxiosMember.SpecialDealsUpdate(access)
      await context.commit('mutationsSpecialDealsUpdate', response)
      return response
    },
    async actionsSpecialDealsStatus (context, access) {
      var response = await AxiosMember.SpecialDealsStatus(access)
      await context.commit('mutationsSpecialDealsStatus', response)
      return response
    },
    async actionsSpecialDealsDelete (context, access) {
      var response = await AxiosMember.SpecialDealsDelete(access)
      await context.commit('mutationsSpecialDealsDelete', response)
      return response
    },
    async actionsSpecialDealsProductList (context, access) {
      var response = await AxiosMember.SpecialDealsProductList(access)
      await context.commit('mutationsSpecialDealsProductList', response)
      return response
    },
    async actionsSpecialDealsBuyerList (context, access) {
      var response = await AxiosMember.SpecialDealsBuyerList(access)
      await context.commit('mutationsSpecialDealsBuyerList', response)
      return response
    },
    async actionsSpecialDealsLevelList (context, access) {
      var response = await AxiosMember.SpecialDealsLevelList(access)
      await context.commit('mutationsSpecialDealsLevelList', response)
      return response
    },
    async actionsSpecialDealsCheckTypeOptions (context, access) {
      var response = await AxiosMember.SpecialDealsCheckTypeOptions(access)
      await context.commit('mutationsSpecialDealsCheckTypeOptions', response)
      return response
    },
    async actionsShopAdsDetail (context, access) {
      var response = await AxiosMember.ShopAdsDetail(access)
      await context.commit('mutationsShopAdsDetail', response)
      return response
    },
    async actionsShopAdsUpdate (context, access) {
      var response = await AxiosMember.ShopAdsUpdate(access)
      await context.commit('mutationsShopAdsUpdate', response)
      return response
    },
    async actionsShopAdsDelete (context, access) {
      var response = await AxiosMember.ShopAdsDelete(access)
      await context.commit('mutationsShopAdsDelete', response)
      return response
    },
    async actionsGetShopADS (context, access) {
      var response = await AxiosMember.GetShopADS(access)
      await context.commit('mutationsGetShopADS', response)
      return response
    },
    async actionsMemberShopSearch (context, access) {
      var response = await AxiosMember.MemberShopSearch(access)
      await context.commit('mutationsMemberShopSearch', response)
      return response
    },
    async actionsMemberPointRedeemProducts (context, access) {
      var response = await AxiosMember.MemberPointRedeemProducts(access)
      await context.commit('mutationsMemberPointRedeemProducts', response)
      return response
    },
    async actionsCreateOrderPointRedeem (context, access) {
      var response = await AxiosMember.CreateOrderPointRedeem(access)
      await context.commit('mutationsCreateOrderPointRedeem', response)
      return response
    },
    async actionsMemberCustomCouponDetail (context, access) {
      var response = await AxiosMember.MemberCustomCouponDetail(access)
      await context.commit('mutationsMemberCustomCouponDetail', response)
      return response
    },
    async actionsMemberCustomCouponSave (context, access) {
      var response = await AxiosMember.MemberCustomCouponSave(access)
      await context.commit('mutationsMemberCustomCouponSave', response)
      return response
    },
    async actionsManageStatusMember (context, access) {
      var response = await AxiosMember.ManageStatusMember(access)
      await context.commit('mutationsManageStatusMember', response)
      return response
    },
    async actionsUpdateStatusMember (context, access) {
      var response = await AxiosMember.UpdateStatusMember(access)
      await context.commit('mutationsUpdateStatusMember', response)
      return response
    }
  }
}

export default ModuleMember
